import { createEntityAdapter } from "@reduxjs/toolkit";
import { RESULTS_PER_PAGE } from "constants";
import { apiSlice } from "features/api/apiSlice";
import { formatDate } from "utils/helpers";

const configurationAdapter = createEntityAdapter({});

const initialState = configurationAdapter.getInitialState({ size: 0 });

export const configurationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getConfigurations: builder.query({
      query: (searchParams) =>
        `/configurations?${searchParams}&limit=${RESULTS_PER_PAGE}`,
      transformResponse: (response) => {
        // Flatten all group arrays into one
        const fetchedConfigurations = Object.entries(response).flatMap(([group, configs]) =>
          configs.map((config) => {
            const {
              value,
              created_at,
              updated_at,
              enabled,
              ...configProps
            } = config;

            configProps["enabled"] = enabled ? "Yes" : "No";

            return {
              ...configProps,
              value,
              created_at: formatDate(created_at),
            };
          })
        );

        return configurationAdapter.setAll(
          { ...initialState, size: response?.total },
          fetchedConfigurations
        );
      },

      providesTags: (result) =>
        result
          ? [
            ...result.ids.map((id) => ({ type: "Configurations", id })),
            { type: "Configurations", id: "PARTIAL-LIST" },
          ]
          : [{ type: "Configurations", id: "PARTIAL-LIST" }],
    }),
    getConfiguration: builder.query({
      query: (id) => `/configurations/${id}`,
      providesTags: (result, error, id) => [{ type: "Configurations", id }],
    }),
    updateConfiguration: builder.mutation({
      query: (data) => ({
        url: `/configurations`,
        method: "PATCH",
        body: JSON.stringify(data), // expects an array of { id, name, value }
      }),
      invalidatesTags: (result, error, args) =>
        Array.isArray(args)
          ? args.map((item) => ({ type: "Configurations", id: item.id }))
          : [{ type: "Configurations", id: args?.id }],
    }),
  })
})

export const {
  useGetConfigurationQuery,
  useGetConfigurationsQuery,
  useUpdateConfigurationMutation,
} = configurationApiSlice